import getQueryParams from "ui/router/utils/getQueryParams";
import { TransactionsRoutes } from "../router/TransactionsRouter";
import { SendStateNames } from "../transactions.types";
import { config } from "common/config";

export class QRCodeDto {
    address?: string;
    amount?: string;
    concept?: string;
    reference?: string;
    paymentId?: string;

    static generatePaymentUrl(qrCode: string, balance: string, path: string = TransactionsRoutes.SEND_DETAILS): string {
        try {
            const parsedQRCode = JSON.parse(qrCode);
            return this.buildPathWithQueryParams(parsedQRCode, balance, path);
        } catch (error) {
            try {
                const parsedQRCode = getQueryParams(qrCode);
                return this.buildPathWithQueryParams(parsedQRCode, balance, path);
            } catch (error) {
                return path;
            }
        }
    }

    private static buildPathWithQueryParams(parsedQRCode: Record<string, string | null>, balance: string, path: string): string {
        const queryParams = new URLSearchParams();
        if (parsedQRCode.amount) queryParams.append(SendStateNames.AMOUNT, parsedQRCode.amount);
        if (parsedQRCode.address) queryParams.append(SendStateNames.DESTINATION_ADDRESS, parsedQRCode.address);
        if (parsedQRCode.destinationAddress) queryParams.append(SendStateNames.DESTINATION_ADDRESS, parsedQRCode.destinationAddress);
        // Concept : es el concepto de la transferencia
        if (parsedQRCode.concept) queryParams.append(SendStateNames.CONCEPT, parsedQRCode.concept);
        // reference : es la referencia que se utiliza en el payment gateway
        if (parsedQRCode.reference) queryParams.append(SendStateNames.REFERENCE, parsedQRCode.reference);
        // paymentId : paymentId es el identificador del payment gateway
        if (parsedQRCode.paymentId) queryParams.append(SendStateNames.PAYMENT_ID, parsedQRCode.paymentId);
        if (parsedQRCode.amount) {
            const canPay = BigInt(balance) >= BigInt(parsedQRCode.amount);
            path = canPay && BigInt(parsedQRCode.amount) > 0 ? TransactionsRoutes.SEND_CONFIRMATION : TransactionsRoutes.SEND_DETAILS;
        }
        const pathWithQueryParams = `${path}?${queryParams.toString()}`;
        return pathWithQueryParams;
    }

    static generateShareUrl(walletAddress: string | undefined): string {
        return `${config.appUrl}${TransactionsRoutes.SEND_DETAILS}?destinationAddress=${walletAddress}`;
    }

    static downloadQR(svg: SVGElement): void {
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svg);

        const canvas = document.createElement("canvas");
        const img = new Image();
        const padding = 10;
        img.onload = () => {
            const width = img.width + padding * 2;
            const height = img.height + padding * 2;

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, width, height);
                ctx.drawImage(img, padding, padding);
                const pngUrl = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.href = pngUrl;
                link.download = "qr-code.png";
                link.click();
            }
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgString)}`;
    }
}
